"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const v4_1 = require("zod/v4");
exports.TaskSchema = v4_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.PyXlsx2Csv2ConvertRangeSchema.extend({
        srcArtifactSlug: v4_1.z.string(),
    }),
    tape_sanitizer_1.PyXlsx2Csv2ExtractValuesSchema.extend({
        srcArtifactSlug: v4_1.z.string(),
    }),
]);
exports.UiConfigSchema = v4_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.PyXlsx2Csv2ConvertRangeSchema,
    tape_sanitizer_1.PyXlsx2Csv2ExtractValuesSchema,
]);
exports.nodeType = 'operation_pyXlsx2csv2';
//# sourceMappingURL=types.js.map